import React, { Suspense, useState } from "react";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { Spin } from "antd";
import Loading from "components/shared-components/Loading";
import AppLoyaltyViews from "views/loyalty-app/app-loyalty-views";
import { ROUTES } from "views/loyalty-app/app-loyalty-views/LoyaltyRoutes";
import { useHistory } from "react-router-dom";
import BottomNavigation from "./navigation/bottomNavigation";
import TopNavigation from "./navigation/topNavigation";
import LoyaltyLayoutProvider from "./context";

export const AppLoyaltyLayout = () => {
  const { status } = useThemeSwitcher();
  const history = useHistory();
  const [path, setPath] = useState(ROUTES.HOME);
  const [pathTitle, setPathTitle] = useState("");
  const [publicOrgId, setPublicOrgId] = useState(null);

  const handleNavigation = (path) => {
    setPath(path);
    history.push(path);
  };

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  return (
    <Suspense fallback={<Spin />}>
      <LoyaltyLayoutProvider
        value={{
          path,
          pathTitle,
          setPathTitle,
          setPath,
          publicOrgId,
          setPublicOrgId,
        }}
      >
        <div className="h-100 loyalty-layout">
          <div className="loyalty-layout-header">
            <TopNavigation setPath={setPath} />
          </div>
          <div className="loyalty-layout-content">
            <AppLoyaltyViews />
          </div>
          <div className="loyalty-layout-bottom-nav">
            <BottomNavigation
              active={path}
              handleNavigation={handleNavigation}
            />
          </div>
        </div>
      </LoyaltyLayoutProvider>
    </Suspense>
  );
};

export default AppLoyaltyLayout;
